import type { IProductRankingListData, IProductRankingListResponse } from './types/product';

export function normalizeProductRankingListData(data: undefined): undefined;
export function normalizeProductRankingListData(
  data: IProductRankingListData,
): IProductRankingListData;
export function normalizeProductRankingListData(
  data: IProductRankingListData | undefined,
): IProductRankingListData | undefined {
  if (!data || Array.isArray(data.list) || !Array.isArray(data.products)) {
    return data;
  }

  return {
    ...data,
    list: data.products,
  };
}

export function normalizeProductRankingListResponse(
  response: IProductRankingListResponse,
): IProductRankingListResponse {
  const data = normalizeProductRankingListData(response.data);
  return data === response.data ? response : { ...response, data };
}
